export const DWM_CHART_TYPES = Object.freeze({
    BAR: 'bar',
    LINE: 'line',
});
